import { useState } from "react";

const AdminDashboard = () => {
  const [blog, setBlog] = useState({
    title: "",
    content: "",
    image: "",
    date: "",
    readTime: "",
  });

  const submit = async () => {
    if (!blog.title || !blog.content || !blog.image || !blog.date || !blog.readTime) {
      alert("Please fill all fields");
      return;
    }

    try {
      const res = await fetch("https://thakkar-backend.vercel.app/api/blog", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(blog),
      });

      const data = await res.json();

      if (!data.success) {
        alert("❌ Unauthorized or failed to post blog");
        return;
      }

      alert("✅ Blog posted successfully");

      setBlog({
        title: "",
        content: "",
        image: "",
        date: "",
        readTime: "",
      });
    } catch {
      alert("❌ Server error");
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 px-3 sm:px-4 py-6 sm:py-10">
      <div className="max-w-4xl mx-auto bg-white rounded-xl sm:rounded-2xl shadow-lg p-4 sm:p-8">

        {/* HEADER */}
        <div className="mb-6 border-b pb-3">
          <h2 className="text-xl sm:text-3xl font-bold text-gray-800">
            Admin Blog Dashboard
          </h2>
          <p className="text-gray-500 text-sm sm:text-base mt-1">
            Create and publish real estate blogs
          </p>
        </div>

        {/* IMAGE URL */}
        <div className="mb-5">
          <label className="text-sm font-medium text-gray-700">
            Blog Cover Image URL
          </label>

          <input
            type="text"
            value={blog.image}
            onChange={(e) => setBlog({ ...blog, image: e.target.value })}
            className="w-full mt-2 px-4 py-3 border rounded-lg text-sm sm:text-base"
            placeholder="https://example.com/image.jpg"
          />

          {blog.image && (
            <img
              src={blog.image}
              alt="Preview"
              className="mt-4 h-40 sm:h-48 w-full object-cover rounded-xl border"
            />
          )}
        </div>

        {/* DATE & READ TIME */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-5">
          <input
            type="date"
            value={blog.date}
            onChange={(e) => setBlog({ ...blog, date: e.target.value })}
            className="w-full px-4 py-3 border rounded-lg text-sm sm:text-base"
          />
          <input
            type="text"
            placeholder="Read Time (e.g. 5 min)"
            value={blog.readTime}
            onChange={(e) => setBlog({ ...blog, readTime: e.target.value })}
            className="w-full px-4 py-3 border rounded-lg text-sm sm:text-base"
          />
        </div>

        {/* TITLE */}
        <input
          placeholder="Blog Title"
          value={blog.title}
          onChange={(e) => setBlog({ ...blog, title: e.target.value })}
          className="w-full mb-5 px-4 py-3 border rounded-lg text-sm sm:text-base"
        />

        {/* CONTENT */}
        <textarea
          rows="6"
          placeholder="Blog content..."
          value={blog.content}
          onChange={(e) => setBlog({ ...blog, content: e.target.value })}
          className="w-full mb-6 px-4 py-3 border rounded-lg text-sm sm:text-base"
        />

        {/* SUBMIT BUTTON */}
        <button
          onClick={submit}
          className="
            w-full bg-black text-white py-3 sm:py-4
            rounded-xl font-semibold text-sm sm:text-base
            active:scale-95 transition
          "
        >
          Publish Blog
        </button>

      </div>
    </div>
  );
};

export default AdminDashboard;
